import { render, staticRenderFns } from "./EmailBind.vue?vue&type=template&id=bd31f96c&scoped=true&"
import script from "./EmailBind.vue?vue&type=script&lang=ts&"
export * from "./EmailBind.vue?vue&type=script&lang=ts&"
import style0 from "./EmailBind.vue?vue&type=style&index=0&id=bd31f96c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd31f96c",
  null
  
)

export default component.exports